import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '明星八卦', path: '/category/star-gossip' },
  { label: '综艺热点', path: '/category/variety-show' },
  { label: '影视追踪', path: '/category/film-tv' },
  { label: '社会热点', path: '/category/society' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className="text-xl md:text-2xl font-heading font-bold text-accent-500 whitespace-nowrap">
            吃瓜每日榜单
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-accent-600 bg-accent-100/80'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-accent-500 hover:bg-background-100'
                    : 'text-foreground-800 hover:text-accent-500 hover:bg-background-50/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
          aria-label="菜单"
        >
          <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-3 py-3 text-sm font-medium rounded-lg transition-colors ${
                location.pathname === link.path
                  ? 'text-accent-600 bg-accent-100/80'
                  : 'text-foreground-700 hover:text-accent-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
